module.exports = __webpack_public_path__ + "static/media/bestDestination.c018f652.jpg";